import { Star } from "lucide-react"

export default function Testimonials() {
  const testimonials = [
    {
      name: "Alex K.",
      rank: "Diamond",
      quote: "Found a consistent team to climb with. Went from Gold to Diamond in just two weeks!",
      stars: 5,
    },
    {
      name: "Sarah M.",
      rank: "Platinum",
      quote:
        "As a female gamer, I was worried about toxicity. FragNades matched me with respectful teammates who just want to win.",
      stars: 5,
    },
    {
      name: "Jamal T.",
      rank: "Immortal",
      quote: "The AI matchmaking is scary good. My new squad perfectly complements my playstyle.",
      stars: 4,
    },
  ]

  return (
    <section className="bg-zinc-900/50 py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What Gamers Say</h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">
            Don't take our word for it. Here's what the FragNades community has to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-6 border border-zinc-700">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`h-5 w-5 ${i < testimonial.stars ? "text-yellow-500 fill-yellow-500" : "text-zinc-600"}`}
                  />
                ))}
              </div>
              <p className="text-zinc-300 mb-4 italic">"{testimonial.quote}"</p>
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center text-red-500 font-bold">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="ml-3">
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-zinc-500 text-sm">{testimonial.rank} Rank</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

